import {Component, OnInit} from '@angular/core';
import {HttpClientService} from "../../core/services/http-client.service";
import {CommonService} from "../../core/services/common.service";
import {ToastService} from "../../core/services/toast.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit{
  product: any;
  brands: any[] = [];
  mainBanners: any[] = [];
  loading: boolean=false;
  productCategories:any[] = [];
  sections: any[] = [];
  constructor(private http: HttpClientService, private common: CommonService, private toast: ToastService) {
  }
  images: any[] = [{
    title: "Samsung Galaxy Z Fold and Flip With Galaxy AI",
    src: "https://img-prd-pim.poorvika.com/pageimg/Samsung-Galaxy-Z-Fold7-Z-Flip6-Galaxy-AI.webp",
    linkTo: "#"
  },{
    title: "iPhone Nothing-R 3",
    src: "https://img-prd-pim.poorvika.com/pageimg/Nothing-R-Phone-3-Available-Now-W.webp",
    linkTo: "#"
  },{
    title: "Reno14 Series 5G",
    src: "https://img-prd-pim.poorvika.com/pageimg/Reno-14-Series-5G-1900-x-400.webp",
    linkTo: "#"
  },{
    title: "OnePlus Nord 5 - Light Speed. Night Legend",
    src: "https://img-prd-pim.poorvika.com/pageimg/oneplus-nord-5-w2.webp",
    linkTo: "#"
  }];
  responsiveOptions: any[] = [
    {
      breakpoint: '991px',
      numVisible: 4
    },
    {
      breakpoint: '767px',
      numVisible: 3
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ];

  ngOnInit() {
    this.getBanners();
    this.getFofoBrands();
    this.getSections();
  }

  getSections() {
    this.http.get(`/pages`).subscribe(result => {
      let sections = result.map(res => ({
        ...res,
        sectionData: JSON.parse(res.sectionData)
      }));
      const enhancedSections: any[] = [];
      sections.forEach((sec, i) => {
        enhancedSections.push(sec);

        if (i == 1) {
          enhancedSections.push({
            type: 'brand_slider',
            id: `slider-${i + 1}`,
            data: {
              title: `Brand Slider ${i + 1}`,
              items: this.brands
            }
          });
        }
      });
      this.sections = enhancedSections;
      this.loading = false;
    })
  }

  getFofoBrands() {
    this.http.get("fofo/brands/?"+this.common.stringParams({ categoryId: "3" })).subscribe(
      (data) => {
        const preferredOrder = ['Samsung', 'Apple', 'Vivo'];
        data = data.filter(el => { return ('logoUrl' in el) && el.logoUrl.trim() != ""});
        this.brands = data.sort((a, b) => {
          const rankA = preferredOrder.indexOf(a.name);
          const rankB = preferredOrder.indexOf(b.name);
          if (rankA !== -1 && rankB !== -1) {
            return rankA - rankB;
          }
          if (rankA !== -1) return -1;
          if (rankB !== -1) return 1;
          return b.brandCategory.rank - a.brandCategory.rank;
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.toast.error("Server Error!")
      }
    );
  }

  async getBanners() {
    this.mainBanners = await this.http.get('banner-listing-url?pageUrl=home-main/&websiteName=Store Website').toPromise();
  }
}

